<template>
  <div class="clone-client-form mb-3">
    <h4>Clone Client</h4>
    <div class="mb-2 rounded p-2" style="background-color: #f5f5f5;">
      <router-link
        :to="{ name: 'ManageClients' }"
        class="d-inline"
        style="font-weight: normal;"
      >
        Clients
      </router-link>
      <p class="d-inline pl-1 pr-1">/</p>
      <router-link :to="{}" class="d-inline" style="font-weight: normal;">
        Clone Client
      </router-link>
    </div>
    <hr />
    <a-spin :spinning="Loading">
      <div class="form-group">
        <label for="">
          1. Select incentiveweb client to be cloned:
          <span style="color: red;">*</span>
        </label>
        <select v-model="defaultClient" size="8" class="form-control col-md-6">
          <option
            :value="client"
            v-for="client in getClientsData"
            :key="client.id"
          >
            {{ client.name }}
          </option>
        </select>
      </div>

      <div>
        <label for=""
          >2. Specify new incentiveweb client's required information:</label
        >
        <!-- Input fields first row Section -->
        <div class="grid" style="grid-template-columns: 3fr 1fr 1fr">
          <div class="form-group">
            <label for=""
              >New Client Name: <span style="color: red;">*</span></label
            >
            <input
              type="text"
              name=""
              id=""
              class="form-control"
              v-model="form.name"
            />
          </div>

          <div class="form-group">
            <label for=""
              >Point Ratio (1USD = X Points):
              <span style="color: red;">*</span></label
            >
            <input
              type="text"
              name=""
              id=""
              class="form-control"
              v-model.number="form.ratio"
            />
          </div>

          <div class="form-group">
            <label for="">
              Currency:
            </label>
            <input
              type="text"
              name=""
              id=""
              class="form-control"
              value="Points (default)"
              disabled
            />
          </div>
        </div>

        <!-- Input fields second row Section -->
        <div class="grid" style="grid-template-columns: 1fr 2fr 2fr">
          <div class="form-group">
            <label for="">Billing Code:</label>
            <input
              type="text"
              name=""
              id=""
              class="form-control"
              v-model="form.billingcode"
            />
          </div>

          <div class="form-group">
            <label for="">Program Name (Welcome To):</label>
            <input
              type="text"
              name=""
              id=""
              class="form-control"
              v-model="form.program_name"
            />
          </div>

          <div class="form-group">
            <label for="">Directory Name:</label>
            <input
              type="text"
              name=""
              id=""
              class="form-control"
              v-model="form.directory"
            />
          </div>
        </div>

        <!-- Text Area Section -->
        <div class="grid" style="grid-template-columns: 1fr 1fr 1fr">
          <div>
            <div class="flex">
              <label for="" style="flex-grow: 1;"
                >Welcome Description Message:</label
              >
              <div class="flex">
                <p class="mb-1 bold">Change:&nbsp;</p>
                <b-checkbox class="mb-1" v-model="welcome_msg_changed" />
              </div>
            </div>
            <textarea
              class="form-control"
              rows="8"
              v-model="form.copy"
              :disabled="!welcome_msg_changed"
            ></textarea>
          </div>

          <div>
            <div class="flex">
              <label for="" style="flex-grow: 1;">Program Description:</label>
              <div class="flex">
                <p class="mb-1 bold">Change:&nbsp;</p>
                <b-checkbox class="mb-1" v-model="program_desc_changed" />
              </div>
            </div>
            <textarea
              class="form-control"
              rows="8"
              v-model="form.program_desc"
              :disabled="!program_desc_changed"
            ></textarea>
          </div>

          <div>
            <div class="flex">
              <label for="" style="flex-grow: 1;">Homepage Message:</label>
              <div class="flex">
                <p class="mb-1 bold">Change:&nbsp;</p>
                <b-checkbox class="mb-1" v-model="homepage_msg_changed" />
              </div>
            </div>
            <textarea
              class="form-control"
              rows="8"
              v-model="form.hpMessage"
              :disabled="!homepage_msg_changed"
            ></textarea>
          </div>
        </div>

        <!-- Line Items Section -->
        <div class="mt-3">
          <table class="table table-bordered">
            <thead style="border: 1px solid rgba(0,0,0,0.1);">
              <tr>
                <th scope="col" style="width: 20px;"></th>
                <th scope="col" style="width: 20%;">Country Code</th>
                <th scope="col">Default Client ID</th>
                <th scope="col" style="width: 20px;"></th>
              </tr>
            </thead>
            <tbody style="border: 1px solid rgba(0,0,0,0.1);">
              <template v-for="(lineItem, idx) in lineItems">
                <tr
                  :key="idx + 1"
                  style="border-top: 1px solid rgba(0,0,0,0.1);"
                >
                  <td scope="row">
                    <button
                      :style="
                        `position: relative; bottom: -5px; color: white; ${
                          idx === 0 ? 'visibility: hidden;' : ''
                        }`
                      "
                      class="btn btn-danger btn-sm"
                      @click="lineItems.splice(idx, 1)"
                    >
                      -
                    </button>
                  </td>
                  <td scope="row">
                    <input
                      type="text"
                      name=""
                      id=""
                      class="form-control"
                      v-model="lineItems[idx].countryCode"
                    />
                  </td>
                  <td scope="row">
                    <select
                      name=""
                      id=""
                      class="form-control"
                      v-model="lineItems[idx].defaultClientID"
                    >
                      <option
                        :value="client.id"
                        v-for="client in getClientsData"
                        :key="client.id"
                      >
                        {{ client.name }}
                      </option>
                    </select>
                  </td>
                  <td scope="row">
                    <button
                      style="position: relative; bottom: -5px;"
                      class="btn btn-primary btn-sm"
                      v-show="idx + 1 === lineItems.length"
                      @click="lineItems.push({ ...newLine })"
                    >
                      +
                    </button>
                  </td>
                </tr>
                <tr :key="-1 * (idx + 1)">
                  <td
                    colspan="4"
                    v-show="lineItem.message"
                    class="customPadding"
                  >
                    <small style="color: red;">{{ lineItem.message }}</small>
                  </td>
                </tr>
              </template>
            </tbody>
            <tfoot style="border: 1px solid rgba(0,0,0,0.1);">
              <tr>
                <td colspan="4">
                  <p class="mb-0">
                    Note: Please specify atleast 1 default country code with
                    default client ID.
                  </p>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Button Section -->
        <div class="flex mt-3" style="justify-content: center;">
          <button class="btn btn-primary mr-2" @click="submit">
            Clone Client
          </button>
          <button class="btn btn-primary ml-2" @click="resetForm">Reset</button>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: "CloneClientForm",
  data() {
    return {
      Loading: false,
      program_desc_changed: false,
      welcome_msg_changed: false,
      homepage_msg_changed: false,
      form: {
        defaultClientID: null,
        name: "",
        billingcode: "",
        program_name: "",
        program_desc: "",
        copy: "",
        hpMessage: "",
        company: "",
        currency: 1,
        directory: "",
        ratio: null,
        countryCodes: [],
      },
      newLine: {
        countryCode: "",
        defaultClientID: null,
        message: "",
      },
      lineItems: [{ countryCode: "", defaultClientID: null, message: "" }],
    };
  },
  watch: {
    defaultClient(newVal) {
      this.fetchClientData(newVal.id);
    },
    lineItems: {
      handler(newVal) {
        for (const lineItem of this.lineItems) {
          if (!lineItem.countryCode || !lineItem.defaultClientID) {
            lineItem.message =
              "Please provide country code and default client ID.";
          }
          if (lineItem.countryCode && lineItem.defaultClientID) {
            lineItem.message = "";
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    resetForm() {
      this.defaultClient = null;
      this.form = {
        defaultClientID: null,
        name: "",
        billingcode: "",
        program_name: "",
        program_desc: "",
        copy: "",
        hpMessage: "",
        company: "",
        currency: 1,
        directory: "",
        ratio: null,
        countryCodes: [],
      };
      this.lineItems = [
        { countryCode: "", defaultClientID: null, message: "" },
      ];
      this.program_desc_changed = false;
      this.welcome_msg_changed = false;
      this.homepage_msg_changed = false;
    },
    fetchClientData(clientId) {
      this.Loading = true;
      this.$store
        .dispatch("cloneClient/getClientByID", {
          clientId,
        })
        .then((data) => {
          this.form.directory = data.directory;
          this.form.program_name = data.program_name;
          this.form.program_desc = data.program_desc;
          this.form.copy = data.copy;
          this.form.hpMessage = data.hpMessage;
        })
        .finally(() => {
          this.Loading = false;
        });
    },
    submit() {
      if (!this.defaultClient) {
        alert("Please select default client.");
        return;
      }

      if (!this.form.name) {
        alert("New Client Name field cannot be empty.");
        return;
      }

      if (typeof this.form.ratio !== "number" || this.form.ratio < 0) {
        alert(
          "Point Ratio field is mandatory and can only take positive values."
        );
        return;
      }

      const validatedLineItems = [];
      for (const lineItem of this.lineItems) {
        if (!lineItem.countryCode || !lineItem.defaultClientID) {
          alert(
            "Please provide country code / please select default client ID in highlighted fields."
          );
          return;
        }

        if (lineItem.countryCode && lineItem.defaultClientID) {
          const { message, ...rest } = lineItem;
          validatedLineItems.push({
            ...rest,
          });
        }
      }

      if (validatedLineItems.length < 1) {
        alert(
          "Please specify atleast 1 default country code with default client ID."
        );
        return;
      }

      this.Loading = true;
      this.$store
        .dispatch("cloneClient/cloneClientStore", {
          ...this.form,
          defaultClientID: this.defaultClient.id,
          company: this.defaultClient.name,

          countryCodes: validatedLineItems,
        })
        .then(() => {
          this.$router.push({ name: "cloneClientResult" });
        })
        .catch((err) => {
          alert(err.message);
        })
        .finally(() => {
          this.Loading = false;
        });
    },
  },
  computed: {
    defaultClient: {
      get() {
        return this.$store.getters["cloneClient/GET_CLIENT"];
      },
      set(val) {
        this.$store.commit("cloneClient/SET_CLIENT", val);
      },
    },
    getClientsData() {
      return this.$store.state.cloneClient.getClientsData;
    },
  },
  created() {
    window.scroll(0, 0);
    this.Loading = true;
    this.$store.dispatch("cloneClient/getClients").finally(() => {
      this.Loading = false;
    });

    if (this.defaultClient) {
      this.fetchClientData(this.defaultClient.id);
    }

    // Reload page confirmation when uploading
    window.addEventListener("beforeunload", (e) => {
      if (this.Loading) {
        e.returnValue = "Still Waiting!";
      }
    });
  },
  destroyed() {
    this.$store.commit("cloneClient/RESET_CLIENT");
  },
};
</script>

<style lang="scss" scoped>
.clone-client-form {
  .grid {
    display: grid;
    gap: 15px;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .bold {
    font-weight: bold;
  }

  .customPadding {
    padding: 0 !important;
    padding-left: 1rem !important;
    padding-bottom: 1rem !important;
  }
}
</style>
